import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import { scaleOrdinal, scaleSequential } from 'd3-scale';
import {schemeBlues, schemeCategory10, schemeSet3, schemeTableau10} from 'd3-scale-chromatic';

const useStyles = makeStyles(theme => ({
    mainGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        // backgroundColor: '#434941'
    }
}));

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const COLORS = scaleOrdinal(schemeTableau10).range();
//const COLORS = scaleOrdinal(schemeBlues[10]).range();

console.log("COLORS", COLORS);


const MiniPieChart = (props) => {
    const classes = useStyles();




    // const CustomTooltip = ({ active, payload, label }) => {
    //     if (active && payload && payload.length ) {
    //         return (
    //             <div className="custom-tooltip">
    //                 <p className="label">{`${payload[0].payload.data.substr(0,10)}:`}</p>
    //                 <p className="intro"> {payload[0].value} pneus</p>
    //             </div>
    //         );
    //     }
    //
    //     return null;
    // };


    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${props.data[index][props.nameKey]} (${(percent * 100).toFixed(0)}%)`}
            </text>
        );
    };

    return (
      <React.Fragment>
          {/*<ResponsiveContainer width="100%" height="100%">*/}
              <PieChart width={500} height={500}>
                  <Pie isAnimationActive={false}
                      data={props.data}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={renderCustomizedLabel}
                      outerRadius={'80%'}
                      nameKey={props.nameKey}
                      dataKey={props.dataKey}
                  >
                      {props.data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                  </Pie>
              </PieChart>
          {/*</ResponsiveContainer>*/}
      </React.Fragment>
    );

}

export default (MiniPieChart)
